var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaypalRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,402.3c0,16.7-13.5,30.3-30.3,30.3H30.3C13.6,432.5,0,419,0,402.3V109.7C0,93,13.6,79.5,30.3,79.5h451.5 c16.7,0,30.3,13.6,30.3,30.3L512,402.3L512,402.3z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.4,148.5c-11.2-12.8-32.1-19.2-60.9-19.2h-80.1c-4.8,0-9.6,4.8-11.2,9.6l-32.1,210c0,4.8,3.2,8,6.4,8h49.7 l12.8-78.5v3.2c1.6-4.8,6.4-9.6,11.2-9.6h24c46.5,0,81.7-19.2,93-72.1v-4.8c-1.6,0-1.6,0,0,0C346.9,174.1,343.6,161.3,332.4,148.5",
    fill: "#263b80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.2,199.8V195c0-0.2,0-0.3,0-0.5c-2.9-2-5.5-3.4-7.6-4.3c-9.7-4-19.7-4.8-24.3-4.9l0,0H290l0,0h-49 c-8.3,0.3-10.6,7-11.2,9.9l-12.8,83v2v1.2c1.6-4.8,6.4-9.6,11.2-9.6h24C298.8,271.9,334,252.7,345.2,199.8z",
    fill: "#232c65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361,214.8c-3.6-10-10-16.4-15.7-20.3c0,0.2,0,0.3,0,0.5v4.8c-11.2,52.9-46.5,72.1-93,72.1h-24 c-4.8,0-9.6,4.8-11.2,9.6v-1.2c-0.2,0.4-0.4,0.8-0.5,1.2l-9.1,55.2l-3.3,20.1l0,0l-3.7,22.4c0,3.2,1.6,6.4,6.4,6.4h40 c8,0,10.6-6.3,11.3-9.6l0.3-2.1l0,0l7.7-47.6c0,0,1-11.2,11.9-11.2h4.1c40.1,0,72.1-16,80.1-64.1C364.6,237.6,364.5,225,361,214.8z",
    fill: "#139ad6"
  })));
}

export default SvgPaypalRect;